import React, { useState } from 'react';
import { SEARCHER_CATALOG } from 'shared/searchers';
import { HeroBenefit } from './types';
import { ICONS } from './icons';
import {
  CurrencyToggle,
  SearchToggle,
  showsFlightCurrencyToggle,
} from '../../searchers/shared/FlightToggles';
import '../../searchers/shared/SearchFields.css';

interface HeroSearchCardProps {
  title: string;
  showTitle: boolean;
  activeSearcherId: string;
  activeSearcherLabel: string;
  benefits: HeroBenefit[];
  /** Argentina agencies show the USD/ARS switch on the flights mock (prototipo v18). */
  paisId?: number;
  // When provided, replaces the mock field grid with the real search form for
  // activeSearcherId (used on the real storefront route). Preview leaves this unset.
  renderSearchForm?: (activeSearcherId: string) => React.ReactNode;
}

const HeroSearchCard: React.FC<HeroSearchCardProps> = ({
  title,
  showTitle,
  activeSearcherId,
  activeSearcherLabel,
  benefits,
  paisId,
  renderSearchForm,
}) => {
  const fields = SEARCHER_CATALOG[activeSearcherId]?.fields ?? [];
  const showHeading = Boolean(activeSearcherLabel || (showTitle && title));
  const isVuelos = activeSearcherId === 'vuelos';
  const [oneWay, setOneWay] = useState(false);
  const [currency, setCurrency] = useState('USD');
  const showCurrency = isVuelos && showsFlightCurrencyToggle(paisId);

  return (
    <div className='hero__search-card'>
      {showHeading && (
        <div className='hero__search-card-title'>
          {activeSearcherLabel && (
            <strong className='hero__search-card-title-label'>{activeSearcherLabel}</strong>
          )}
          {showTitle && title && <span className='hero__search-card-title-text'>{title}</span>}
        </div>
      )}
      {renderSearchForm ? (
        renderSearchForm(activeSearcherId)
      ) : fields.length > 0 ? (
        <div className='hero__search-grid'>
          {fields.map((field) => {
            if (isVuelos && field.label === 'Fecha') {
              return (
                <div className='hero__search-field' key={field.label}>
                  <div className='searcher-field__label-row'>
                    <SearchToggle checked={oneWay} label='Solo ida' onChange={setOneWay} />
                  </div>
                  <div className='hero__search-value'>
                    <span aria-hidden='true' className='hero__search-glyph'>
                      {field.glyph}
                    </span>
                    <span className='hero__search-value-text'>
                      {oneWay ? 'Ida' : field.value}
                    </span>
                  </div>
                </div>
              );
            }

            return (
              <div className='hero__search-field' key={field.label}>
                <label>{field.label}</label>
                <div className='hero__search-value'>
                  <span aria-hidden='true' className='hero__search-glyph'>
                    {field.glyph}
                  </span>
                  <span className='hero__search-value-text'>{field.value}</span>
                </div>
              </div>
            );
          })}
          {isVuelos ? (
            <div className='searcher-form__currency-actions'>
              {showCurrency ? (
                <CurrencyToggle currency={currency} onChange={setCurrency} />
              ) : null}
              <button className='hero__search-btn' type='button'>
                Buscar
              </button>
            </div>
          ) : (
            <button className='hero__search-btn' type='button'>
              Buscar
            </button>
          )}
        </div>
      ) : null}
      {benefits.some((benefit) => benefit.show) ? (
        <div className='hero__benefits'>
          {benefits
            .filter((benefit) => benefit.show)
            .map((benefit, index) => {
              const Icon = ICONS[benefit.icon];
              return (
                <div className='hero__benefit' key={`${benefit.title}-${index}`}>
                  <span className='hero__benefit-icon'>
                    <Icon />
                  </span>
                  <b>{benefit.title}</b>
                  <span>{benefit.text}</span>
                </div>
              );
            })}
        </div>
      ) : null}
    </div>
  );
};

export default HeroSearchCard;
